// trigger build
import { createRoot } from 'react-dom/client';

//import * as Sentry from '@sentry/react';
import App from './App';

import './i18n';

// Sentry.init({
//   dsn: 'https://d6af18b683638baede818f6bc5112701@o280086.ingest.sentry.io/4506778987069440',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   enabled: process.env.NODE_ENV !== 'development',
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 1.0,
//   replaysOnErrorSampleRate: 1.0,
// });

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
